module.exports = __webpack_public_path__ + "img/cst_channel_active.7a941bb7.svg";